<div class="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
  <nav>
    <ol class="flex items-center gap-2">
      <li>
        <a routerLink="/" class="inline-flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-600 hover:dark:text-blue-300">
          Dashboard
        </a>
      </li>

      @for (item of items; track item.label) {
        <li class="flex items-center gap-2 text-gray-800 dark:text-white/90">
          <svg class="stroke-current" width="15" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          @if (item.route) {
            <a [routerLink]="item.route" class="inline-flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-600 hover:dark:text-blue-300">
              {{ item.label }}
            </a>
          } @else {
            <span class="text-xs">
              {{ item.label }}
            </span>
          }
        </li>
      }
    </ol>
  </nav>
</div>